/**
 * @generated SignedSource<<fe3b8fe5334ec13d7893a03f428a8d42>>
 * @relayHash a84fe10735a92a53e7c78b12a12494ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f3b57e29c1ce294be2ba0fadd405512bbc8cbe2c9fd26fea591a6b96106ec095

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBusinessAttachmentsAppMemoQuery } from './JiraBusinessAttachmentsAppMemoQuery.graphql';

import blockAttachmentDownloadSegregation_provider from '@jira/platform__graphql-relay-provider/src/block-attachment-download-segregation.relayprovider';

const node: PreloadableConcreteRequest<JiraBusinessAttachmentsAppMemoQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f3b57e29c1ce294be2ba0fadd405512bbc8cbe2c9fd26fea591a6b96106ec095",
    "metadata": {},
    "name": "JiraBusinessAttachmentsAppMemoQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcblockattachmentdownloadsegregationrelayprovider": blockAttachmentDownloadSegregation_provider
    }
  }
};

export default node;
